import { render, staticRenderFns } from "./SpecialPage.vue?vue&type=template&id=3fbe189a&scoped=true&"
import script from "./SpecialPage.vue?vue&type=script&lang=ts&"
export * from "./SpecialPage.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SpecialPage.vue?vue&type=style&index=1&id=3fbe189a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbe189a",
  null
  
)

export default component.exports